import { BaseEntityForm } from "@cetma/skeleton-app/core/dtos/forms/BaseForm";
import * as yup from "yup";

const environmentCategoryForm: BaseEntityForm = {
    columns: [    
        { field: 'environmentCategoryId', fieldType: 'id', hideColumn: true, headerName: 'Id' },
        { field: 'environmentCategoryName', fieldType: 'string', hideColumn: false, headerName: 'Name', flex: 1 },
    ],
    validation:  yup.object({
        environmentCategoryName: yup.string().required("error.validation.required")
    })
}

export default environmentCategoryForm;